export enum UserHasQualificationTransitionTypeEnum {
  RENEWAL = "RENEWAL",
  RECYCLING = "RECYCLING"
}
